import { api } from '@/lib/api'

type StoreCardEncryptionKeyRequest = {
  publicKeyPem: string
}

export function storeCardEncryptionKey(data: StoreCardEncryptionKeyRequest) {
  return api.post<void>(`/v1/me/card-encryption-keys`, data)
}
